import { Box, Stack, Typography, styled } from "@mui/material";
import React from "react";
import CheckboxController from "../../../../components/CheckboxSelector/CheckboxSelector";
import {
  medicalHistoryComorbidityOptions,
  presentingComplaintOptions,
} from "./formFootOptions";
import {
  InputLabelStyled,
  ParentSelectBox,
} from "../../DiabeticForm/sub-form-sections/PresentingComplaintSection";
import RadioButtonController from "../../../../components/RadioButtonController/RadioButtonController";
import {
  onTreatmentOpt,
  treatmentTypeOption,
} from "../../DiabeticForm/sub-form-sections/formOptions";
import {
  CustomInputLable,
  InputContainer,
  ParentContainerSection,
} from "../FootForm";

export const GridColumnV2 = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(42%, 1fr))",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "70% 30%",
    margin: "0 auto",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
    margin: "0 auto",
  },
}));

const FocusedHistory = (props) => {
  const { errors, control, getvalues, watch } = props;

  return (
    <>
      <ParentContainerSection heading="Section B: Focused History">
        <GridColumnV2>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Typography
              variant="body1"
              sx={{
                display: "inline",
                color: (theme) => theme.palette.primary.main,
                fontWeight: "bold",
                mt: 1,
              }}
            >
              Presenting Complaint
            </Typography>
            <CheckboxController
              name="focused_history.presenting_complaint"
              isRow={false}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={presentingComplaintOptions}
              isHorizantalPadding={false}
              isDisabled
              isMarginLeft={true}
            />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Typography
              variant="body1"
              sx={{
                display: "inline",
                color: (theme) => theme.palette.primary.main,
                fontWeight: "bold",
                mt: 1,
              }}
            >
              Past Medical History/Comorbidity
            </Typography>
            <CheckboxController
              name="focused_history.past_medical_history"
              isRow={false}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={medicalHistoryComorbidityOptions}
              isHorizantalPadding={false}
              isDisabled
              isMarginLeft={true}
            />
          </Box>
        </GridColumnV2>
        <InputContainer>
          <CustomInputLable required>Are you on treatment?</CustomInputLable>
          <RadioButtonController
            name="focused_history.on_treatment"
            control={control}
            errors={errors}
            options={onTreatmentOpt}
            isRow
            isDisabled
          />
        </InputContainer>

        {watch("focused_history.on_treatment") === "1" && (
          <>
            <InputContainer>
              <CustomInputLable>If Yes</CustomInputLable>
              <CheckboxController
                name={"focused_history.treatment_type"}
                isRow={true}
                isMultiCheckbox={true}
                control={control}
                errors={errors}
                options={treatmentTypeOption}
                isHorizantalPadding={true}
                size="small"
                isDisabled
                isCustomPadding
              />
            </InputContainer>
          </>
        )}
      </ParentContainerSection>
    </>
  );
};

export default FocusedHistory;
